import React from 'react';
import Modal from 'react-modal';
import { AlertTriangle, X } from 'lucide-react';

const DeleteConfirmModal = ({ isOpen, onClose, onConfirm, propertyTitle, isLoading = false }) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      className="bg-white rounded-lg shadow-2xl max-w-md mx-auto mt-20 p-6 z-50"
      overlayClassName="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-40"
      ariaHideApp={false}
    >
      <div className="space-y-4">
        {/* Header */}
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-3">
            <AlertTriangle size={28} className="text-red-600" />
            <h2 className="text-xl font-bold text-prose-brand">Delete Property</h2>
          </div>
          <button
            onClick={onClose}
            className="p-1 hover:bg-gray-100 rounded-lg transition duration-200"
          >
            <X size={20} className="text-prose-black/60" />
          </button>
        </div>

        {/* Message */}
        <div className="bg-red-50 border border-red-200 rounded-lg p-3">
          <p className="text-prose-black/80">
            Are you sure you want to delete <span className="font-semibold">{propertyTitle}</span>?
          </p>
          <p className="text-sm text-prose-black/60 mt-2">
            This action cannot be undone. All related bookings will also be deleted.
          </p>
        </div>

        {/* Actions */}
        <div className="flex gap-3 justify-end pt-2">
          <button
            onClick={onClose}
            disabled={isLoading}
            className="px-4 py-2 border border-gray-300 text-prose-black rounded-lg hover:bg-gray-100 transition duration-200 font-semibold disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={isLoading}
            className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition duration-200 font-semibold disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isLoading ? 'Deleting...' : 'Delete'}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteConfirmModal;
